import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

const BACKGROUND_REPEAT_VALUES = ['no-repeat', 'repeat', 'repeat-x', 'repeat-y'] as const;

const BACKGROUND_SIZE_VALUES = ['auto', 'cover', 'contain'] as const;

const BACKGROUND_POSITION_VALUES = [
  'left top',
  'left center',
  'left bottom',
  'center top',
  'center center',
  'center bottom',
  'right top',
  'right center',
  'right bottom'
] as const;

// TODO this enum already exists, unify it
export enum BackgroundLayout {
  Centered = 'centered',
  FullBleed = 'fullBleed'
}

export const SectionWidgetStaticSchema = BaseWidgetSchema(WidgetType.Section).extend({
  style: z.object({
    backgroundColor: z.string().optional().nullable(),
    backgroundImage: z.string().optional().nullable(),
    backgroundRepeat: z.enum(BACKGROUND_REPEAT_VALUES).optional().nullable(),
    backgroundSize: z.enum(BACKGROUND_SIZE_VALUES).optional().nullable(),
    backgroundPosition: z.enum(BACKGROUND_POSITION_VALUES).optional().nullable(),
    backgroundLayout: z.nativeEnum(BackgroundLayout).optional().nullable()
  }),
  layout: z.record(
    z.string(),
    z.object({
      span: z.number(),
      column: z.number(),
      height: z.union([z.number(), z.string()]),
      isDraggable: z.boolean(),
      isDeletable: z.boolean()
    })
  ),
  parentId: z.string(),
  columnAmount: z.number(),
  columnGap: z.number()
});

export type SectionWidgetStaticSchemaType = z.infer<typeof SectionWidgetStaticSchema>;
